import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import "./MindMap.css";

const SubBranch = ({ title, rank, links, isOpen, onClick }) => {
  const {courseSlug} = useParams();
  const isLeaf = links.every((link) => typeof link === "object" && link.url);

  return (
    <div className={`branch expandable ${isOpen ? "open" : ""}`}>
      <div className="node black toggle" onClick={onClick}>
        {title}
      </div>
      {isOpen && (
        <div className={`children ${isLeaf ? "leaf" : ""}`}>
          {links.map((link, idx) => (
            <div key={idx} className={`node ${isLeaf ? "leaf-item" : ""}`}>
              <Link to={link.url}>{link.label}</Link>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const TreeNode = ({ number, label, title, subtitle, childrenNodes, isFirst, onToggle, isOpen }) => {
  const [openSubIndex, setOpenSubIndex] = useState(null);

  const toggleSubBranch = (index) => {
    setOpenSubIndex((prev) => (prev === index ? null : index));
  };

  return (
    <div className={`branch expandable ${isOpen ? "open" : ""} ${isFirst ? "first-branch" : ""}`}  >
   <div className="node orange toggle" onClick={onToggle}>
        <span className="node-number">{number}</span>{" "}
        <span className={`node-title ${isOpen ? "selected" : ""}`}>{title}</span>
          {childrenNodes.length > 0 && (
          <span style={{ marginLeft: 8, fontSize: 11, color: "#f5ab66" }}>
            {isOpen ? "▼" : null}
          </span>
        )}
        <br />
        <span className="black">{subtitle}</span>
      </div>
      {isOpen && (
        <div className="children">
          {childrenNodes.map((child, idx) => (
            <SubBranch
              key={idx}
              {...child}
              isOpen={openSubIndex === idx}
              onClick={() => toggleSubBranch(idx)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export { TreeNode };